import React, { Component } from "react";
import { Col, Container, Row, Badge } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import moment from 'moment'
import Modal from 'react-modal'
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import Loader from "react-loader-spinner";
const formatter = buildFormatter(spanishStrings)

class RHContadorPage extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      date: moment().format('YYYY-MM-DD'),
      view: 'list_facturas',
      arrayListFacturas: [], 
      indexFactura: 0,
    }

  }

  componentDidMount() {
    //Petition wuuuu
    this.getListFacturacion()
    this.props.onRef(this)
  }

  render() {
    const {
      arrayListFacturas,
    } = this.state

    return (
      <>
        <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
          {/* Principal Container */}
          <div style={{ background: '#44bd32', height: 190, overflow: 'hidden', position: 'absolute', top: 0, left: 0, right: 0, zIndex: 1, }} >
            <Container>
              <Row className={'facturacionHeader__row'}>
                <Col xs={'2'}>
                  <img alt={"img"} src={ 'img/pos/logo.png' } className={'facturacionHeader__profile'} />
                </Col>
                <Col className={'facturacionHeader__description'}>
                  <p>ADMINISTRACIÓN<br /><span>Carnicerías Hermanos González</span></p>
                </Col>
              </Row>
            </Container>
          </div>

          { this.state.view === 'list_facturas' ? this.makeViewFacturas() : null }
          { this.state.view === 'factura_view' ? this.makeViewFacturaInformation() : null }
        </div>
      </>
    );
  }

  makeViewFacturas() {
    const {
      arrayListFacturas,
    } = this.state

    return (
      <Container className={'facturacionBody'}>
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col style={{ background: '#fff', padding: 15, }} className={'z-depth-1'}>
            <Row>
              <Col xs={'3'}>
                <b>CLIENTE</b>
              </Col>
              <Col xs={'2'}>
                <b>CORREO</b>
              </Col>
              <Col xs={'2'}>
                <b>TELEFONO</b>
              </Col>
              <Col xs={'2'}>
                <b>DIRECCION</b>
              </Col>
              <Col xs={'2'}>
                <b>FECHA</b>
              </Col>
              <Col xs={'1'}>
                <b>ESTATUS</b>
              </Col>
            </Row>
            {
              arrayListFacturas.map((t,e) => (
                <Row
                  onClick={ () => {
                    this.onSelectFacturaInformacion(e)
                  }}
                    key={`ws_list_compra_${e}`}
                    style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                    className={`regControlProductoPage__content`}
                  >
                  <Col xs={'3'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>{t.nombreCliente}</p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>{t.email}</p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>{t.telefono}</p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <p style={{ color: '#333' }}>
                    {`
                      ${t.direccion_calle !== '' ? t.direccion_calle : ''}
                      ${t.direccion_colonia !== '' ? t.direccion_colonia : ''}
                      ${t.direccion_noext !== '' ? t.direccion_noext : ''}
                      ${t.direccion_noint !== '' ? t.direccion_noint : ''}
                      ${t.direccion_cp !== '' ? t.direccion_cp : ''}
                      ${t.direccion_ciudad !== '' ? t.direccion_ciudad : ''}
                      ${t.direccion_estado !== '' ? t.direccion_estado : ''}
                    `}
                    
                    </p>
                  </Col>
                  <Col xs={'2'} className="regVentaPage__listProduct">
                    <TimeAgo style={{ color: '#444', }} className="__listViewPending_time" date={t.created_at} formatter={formatter} />
                  </Col>
                  <Col xs={'1'} className="regVentaPage__listProduct">
                    <Badge color={'danger'}>{ t.status === 0 ? 'CANCELADA' : null }</Badge>
                    <Badge color={'warning'}>{ t.status === 1 ? 'PENDIENTE' : null }</Badge>
                    <Badge color={'success'}>{ t.status === 2 ? `FACTURADO` : null }</Badge>
                  </Col>
                </Row>
              ))
            }
          </Col>
        </Row>
      </Container>
    )
  }

  setEmitFactura() {
    const {
      arrayListFacturas,
      indexFactura,
    } = this.state
    const info = arrayListFacturas[indexFactura]
     fetch(this.getURLByOPT('setEmitFactura'), this.headersPOST({ id_facturacion: info.id_facturacion }))
    .then(response => response.json())
    .then((response) => {
      this.setState({
        view: 'list_facturas',
      })

      this.getListFacturacion()
    }).catch(() => {  })    
  }

  makeViewFacturaInformation() {
    const {
      arrayListFacturas,
      indexFactura,
    } = this.state
    const info = arrayListFacturas[indexFactura]

    let grandTotal = 0
    if(info.arr.length > 0) {
      info.arr.map((t) => { grandTotal += ( t.total )})
    }
    return (
      <Container className={'facturacionBody'}>
        <Row style={{ width: '99%', margin: '0 auto' }}>
          <Col style={{ background: '#fff', padding: 15, }} className={'z-depth-1'}>
            <Row>
              <Col>
                <h4 style={{ cursor: 'pointer', }} onClick={() => { this.setState({ view: 'list_facturas', }) }}>Regresar</h4>
                <h4>Información fiscal</h4>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Razón social</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.razon_social} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>RFC</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.rfc} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Teléfono</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.telefono} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Correo electrónico</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.email} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Calle</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_calle} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Colonia</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_colonia} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Nº Exterior</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_noext} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Nº Interior</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_noint} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Código postal</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_cp} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p style={{ margin: 0, }}>Ciudad</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_ciudad} />
                  </Col>
                  <Col>
                    <p style={{ margin: 0, }}>Estado</p>
                    <input style={{ width: '100%', marginBottom: 10, }} type="text" disabled={"disabled"} value={info.direccion_estado} />
                  </Col>
                </Row>
                <Row>
                  <button
                    onClick={() => {
                      this.setEmitFactura()
                    }}
                    className={'btn btn-primary'}
                    >Factura realizada</button>
                </Row>
              </Col>

              <Col>
                <h4>Recibos:</h4>

                <div>
                  {
                    info.arr.map((t,e) => this.makeInfoArr(t,e))
                  }
                  <b>GRAND TOTAL ${this.number_format(grandTotal,2)}</b>
                </div>

              </Col>
            </Row>

          </Col>
        </Row>
      </Container>
    )
  }

  makeInfoArr(t,e) {
    if(t.listado.length === 0) {
      return null
    }

    return (
      <div style={{ marginBottom: 20, }}>
        <Row>
          <Col>Producto</Col>
          <Col>Cantidad</Col>
          <Col>Total</Col>
        </Row>
        {
          t.listado.map((t0,e0) => (
            <Row>
              <Col>{t0.nombre}</Col>
              <Col>{this.number_format(t0.venta_kg,2)}</Col>
              <Col>${this.number_format(t0.venta_pesos,2)}</Col>
            </Row>
          ))
        }
        <div>
          <b>Total ${this.number_format(t.total,2)}</b>
        </div>
      </div>
    )
  }

  getListFacturacion() {
    fetch(this.getURLByOPT('getListFacturacion'), this.headersPOST({  }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrayListFacturas: response, })
    }).catch(() => {  })
  }

  onSelectFacturaInformacion(e) {
    this.setState({
      indexFactura: e,
      view: 'factura_view',
    })

    fetch(this.getURLByOPT('getInfoVentas'), this.headersPOST({ id_facturacion: this.state.arrayListFacturas[e].id_facturacion }))
    .then(response => response.json())
    .then((response) => {
      let arrayListFacturas =  this.state.arrayListFacturas
      arrayListFacturas[e].arr = response
      this.setState({ arrayListFacturas })
    }).catch(() => {  })
  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/${PHP}?opt=${opt}`
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getStyleModal(opt) {
    if(opt === 'isOpenListVentaByID') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '50%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

};

export default withRouter(RHContadorPage)